<mat-checkbox [(ngModel)]="showInUseCprsOnly">Show In Use CPRs Only</mat-checkbox>

<table mat-table [dataSource]="dataSource$" matSort>
  <ng-container matColumnDef="oldCprId">
    <th mat-header-cell mat-sort-header *matHeaderCellDef>ID</th>
    <td mat-cell *matCellDef="let item">{{ item.oldCprId }}</td>
  </ng-container>

  <ng-container matColumnDef="label">
    <th mat-header-cell mat-sort-header *matHeaderCellDef>Location of Use</th>
    <td mat-cell *matCellDef="let item">{{ item.label }}</td>
  </ng-container>

  <ng-container matColumnDef="inUse">
    <th mat-header-cell mat-sort-header *matHeaderCellDef>Status</th>
    <td mat-cell *matCellDef="let item">{{ item.inUse ? '' : 'Not' }} In Use</td>
  </ng-container>

  <ng-container matColumnDef="comment">
    <th mat-header-cell mat-sort-header *matHeaderCellDef>Comment</th>
    <td mat-cell *matCellDef="let item">{{ item.comment }}</td>
  </ng-container>

  <ng-container matColumnDef="updatedAt">
    <th mat-header-cell mat-sort-header *matHeaderCellDef>
      <span *ngIf="!isLoading">Updated At</span>
    </th>
    <td mat-cell *matCellDef="let item">
      <span>{{ item.updatedAt | date: 'medium' : 'UTC' }}</span>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="headings"></tr>
  <tr
    mat-row
    class="row clickable"
    [class.hidden]="isLoading"
    *matRowDef="let row; columns: headings"
    [routerLink]="row._id"
  ></tr>

  <tr class="mat-row" *matNoDataRow [hidden]="isLoading">
    <td class="mat-cell" [attr.colspan]="headings.length">
      <span>No matching data.</span>
    </td>
  </tr>
</table>

@if (isLoading) {
  <suvo-bi-skeleton-table-rows [rowCount]="pageSize" [columnWidths]="[20, 30, 50]" />
}

<mat-paginator [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions" showFirstLastButtons />
